import { render, staticRenderFns } from "./DealPartnerWidget.vue?vue&type=template&id=fb392a16&scoped=true&"
import script from "./DealPartnerWidget.vue?vue&type=script&lang=js&"
export * from "./DealPartnerWidget.vue?vue&type=script&lang=js&"
import style0 from "./DealPartnerWidget.vue?vue&type=style&index=0&id=fb392a16&prod&lang=postcss&scoped=true&"
import style1 from "./DealPartnerWidget.vue?vue&type=style&index=1&id=fb392a16&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb392a16",
  null
  
)

export default component.exports